import NextImage from "next/image"
import { type PropsWithChildren } from "react"
import { Stack, StackItem, Typography } from "@octopus-energy/coral/atoms"
import { useCoralBreakpoints } from "@octopus-energy/coral/hooks"

type Props = PropsWithChildren<{
    title: string
    image?: {
        filename: string
        alt: string
    }
    imageWidth?: number
    imageHeight?: number
}>

export function Hero({ title, image, imageWidth, imageHeight, children }: Props) {
    const { isMaxMd } = useCoralBreakpoints()

    const defaultWidth = isMaxMd ? 200 : 400
    const defaultHeight = isMaxMd ? 200 : 400

    return (
        <>
            <Stack
                justifyContent="space-between"
                alignItems="center"
                flexDirection={{ base: "column", md: "row" }}
                gap={{ base: "lg", md: "xxl" }}
            >
                <StackItem flex={1}>
                    <Typography
                        color="tertiary500"
                        textStyle="homepageTitle"
                        component="h1"
                        textAlign="start"
                    >
                        {title}
                    </Typography>
                </StackItem>
                {image && image.filename && (
                    <NextImage
                        src={image.filename}
                        alt={image.alt}
                        width={imageWidth || defaultWidth}
                        height={imageHeight || defaultHeight}
                    />
                )}
            </Stack>
            {children}
        </>
    )
}
